import React from "react";

import { legendItemStyle, legendStyle } from "../style";
import { landslideIspraLegendLevels } from "./LandslideUtils";
import { natcatSelectionText, natcatEuroText } from "./../LegendUtils";

export const LandslideNatcatRiskTIVLegend = ({
  customLegendStyle = legendStyle,
  title,
  areaUnit,
  indexValues,
}) => {
  return (
    <div style={customLegendStyle}>
      <div>
        <b>{title} </b>
      </div>
      <div>
        <span style={legendItemStyle("#F7F7F7")}></span>
        {landslideIspraLegendLevels().noHazard}: index &lt; {indexValues[1]}
      </div>
      <div>
        <span style={legendItemStyle("#feff73")}></span>
        {landslideIspraLegendLevels().attentionZones}: {indexValues[1]} &le; index &lt; {indexValues[2]}
      </div>
      <div>
        <span style={legendItemStyle("#f5cb40")}></span>
        {landslideIspraLegendLevels().moderate}: {indexValues[2]} &le; index &lt; {indexValues[3]}
      </div>
      <div>
        <span style={legendItemStyle("#e66800")}></span>
        {landslideIspraLegendLevels().medium}: {indexValues[3]} &le; index &lt; {indexValues[4]}
      </div>
      <div>
        <span style={legendItemStyle("#e60200")}></span>
        {landslideIspraLegendLevels().high}: {indexValues[4]} &le; index &lt; {indexValues[5]}
      </div>
      <div>
        <span style={legendItemStyle("#730102")}></span>
        {landslideIspraLegendLevels().veryHigh}: index &ge; {indexValues[5]}
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          {natcatSelectionText}. The index is total insured value (TIV) (given in millions of {natcatEuroText}
          ) for policies with landslide risks P3(high) or P4(very high). The value is computed per {areaUnit}.
          © CyStellar, Data from IdroGEO ISPRA (v. 4.0 – 2020-2021) processed by CyStellar
        </span>
      </div>
    </div>
  );
};
